/**
* Created by vouill on 11/14/17.
*/

<template>
  <div
    v-if="show"
    class="center-container">
    <metis-logo :rotate="true" />
  </div>
</template>
<style scoped>
.center-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
}
</style>
<script>
import MetisLogo from "./metis-logo";
export default {
  name: "Loading",
  components: { MetisLogo },
  created: function() {
    this.timeoutId = setTimeout(() => {
      this.show = true;
    }, 200);
  },
  destroyed: function() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },
  data() {
    return {
      show: false
    };
  }
};
</script>
